const groupPrefix = createApiRoute(ApiModule.AUTH, ApiAuthorization.PUBLIC, ApiDataModel.EMPLOYEE)

export const apiRegister = {
	registerFetchDataFromInviteToken: async (token: string): Promise<IRegisterInvitation> => {
		const { data } = await apiCommon<IRegisterInvitationJson>(`${groupPrefix}/invitations/${token}`, {
			method: 'GET',
		})

		return invitationToModel(data)
	},

	registerValidateAndSendToken: async (registerData: IPreRegisterForm): Promise<void> => {
		const obj = preRegisterFormToJson(registerData)
		await apiCommon(`${groupPrefix}/pre-register`, {
			method: 'POST',
			body: obj,
		})
	},

	register: async (model: IRegister): Promise<IUserModel> => {
		const obj = registerModelToJSON(model)
		const { data } = await apiCommon<IUser>(`${groupPrefix}/register`, {
			method: 'POST',
			body: obj,
		})
		return User(data)
	},
}
